import { URLS, interact } from "fire-wind-water";
import authService from "@/services/authService";
import { common } from "@/model/common";
import BaseComponent from "@/components/BaseComponent";
import FormStatus from "../components/FormStatus.vue";
import Header from "@/components/Header";
import { registerModel } from "@/model/register-model";
import { registerData } from "@/model/registerData";
import configMixin from "@/mixin/config";
import Banner from "@/components/Banner";
import WX from "@/model/wx";

export default {
  name: "register",
  components: {
    Header,
    Banner,
    BaseComponent,
    FormStatus,
  },
  mixins: [configMixin],
  data() {
    return {
      url: window.location.href,
      weChatId: common.weChatId,
      memberFormId: common.memberFormId, //  表单ID
      memberSchemaId: common.memberSchemaId,
      schemaId: common.schemaId, // 体系ID
      backUrl: common.backUrl,
      preview: common.preview,
      configId: common.configId,
      userInfo: null,
      openId: "",
      inWeChat: interact.isWeChat,
      verify: "",
      isSubmitting: false,
      formInfo: null,
      formList: [],
      phone: "",
      isLoad: false,
      settingBackUrl: "",
      isTrackClosed: false,
    };
  },
  methods: {
    routerLogin() {
      common.routerPush(this, "login");
    },
    registInit() {
      let self = this;
      if (this.backUrl && common.markCode) {
        this.backUrl = URLS.updateParam(
          "markCode",
          common.markCode,
          this.backUrl
        );
      }
      authService
        .getJsonParams({
          id: common.memberFormId,
          type: "memberForm",
        })
        .then((data) => {
          if (data.result == 0) {
            authService
              .getFormNewRegister({
                tenantId: data.content.tenantId,
                memberFormId: self.memberFormId,
                schemaId: self.schemaId,
                formId: self.memberFormId,
              })
              .then(() => {
                if (data.content.isEnableSignup == 0) {
                  self.url = self.url.replace("register", "login");
                  return window.location.replace(self.url);
                }
              });
          }
        });
    },
    loadFormNew() {
      let self = this;
      this.userInfo = common.getSession();
      authService
        .getForm({
          memberFormId: self.memberFormId,
          formId: self.memberFormId,
          schemaId: self.schemaId,
          isNotAdd: 1,
        })
        .then((data) => {
          self.formInfo = data.content;
          // 表单级自定义字段(编辑器格式)转成与 items 同构后并入,渲染与提交走现有链路
          let customItems = self.formInfo.customItems;
          if (Array.isArray(customItems) && customItems.length > 0) {
            let converted = customItems.map(function (item) {
              let options = (item.listOptions || []).map(function (
                optValue,
                idx
              ) {
                let conf = (item.otherList && item.otherList[idx]) || {};
                return {
                  formId: self.memberFormId,
                  fieldName: item.fieldName,
                  optionId: conf.index,
                  optionValue: optValue,
                  option: optValue,
                  optionLabel: optValue,
                  // sk-input 组件契约: isOther 标记"其他", otherisFillIn(小写i)/otherIsRequire 控制填空
                  isOther: conf.isOther || 0,
                  otherisFillIn: conf.isFillIn || 0,
                  otherIsRequire: conf.isRequire || 0,
                };
              });
              item.required = parseInt(item.required);
              item.isLogin = 0;
              item.isSystemed = 0;
              item.fieldDisplayId = item.displayName;
              item.listOptions = options;
              item.options = options;
              return item;
            });
            self.formInfo.items = registerModel.mergeCustomItems(
              self.formInfo.items,
              converted
            );
          }
          common.handPage(self.formInfo);
          window.$sk.template.update({
            type: "link",
            data: {
              identity: 1,
              weChatId: self.formInfo.authWeChatId || 0,
              skObjectType: "member",
              skObjectId: self.memberFormId,
              meetingInstanceId: "",
              meetingType: "",
              skIsNotLink: "",
              memberFormId: "",
            },
          });
          if (self.formInfo.authWeChatId) {
            self.weChatId = self.formInfo.authWeChatId;
            WX.initWeChatShare(self.formInfo);
          }
          // window.$sk.loading.hide();
          self.initForm();
        });
    },
    initForm() {
      let self = this;
      registerModel.getParamTree(self);
      if (!self.weChatId) {
        if (
          self.formInfo.authWeChatId &&
          self.formInfo.authWeChatId != "0" &&
          self.inWeChat
        ) {
          self.weChatId = self.formInfo.authWeChatId;
          if (!common.getOpenId(self.weChatId)) {
            return;
          }
        }
      }
      setTimeout(() => {
        let backUrlSetting = self.extras.backlink.href;
        self.settingBackUrl = RegExp("^https?:\\/\\/.+").test(backUrlSetting)
          ? backUrlSetting
          : "";
        if (self.userInfo && self.userInfo.session) {
          if (self.backUrl.indexOf("http") > -1) {
            common.handBackUrl(self.backUrl);
          } else if (self.settingBackUrl) {
            window.$sk.goto(self.settingBackUrl);
            return;
          } else {
            common.routerPush(this, "loginSuccess", {
              memberSchemaId: self.formInfo.schemaId,
            });
          }
        }
        window.$sk.loading.hide();
        self.afterLoad();
      }, 500);
    },
    afterLoad() {
      registerModel.record(this);
      if (!this.weChatId) {
        if (
          this.formInfo.authWeChatId &&
          this.formInfo.authWeChatId != "0" &&
          this.inWeChat
        ) {
          this.weChatId = this.formInfo.authWeChatId;
          // window.$model.auth.getUserInfoByToken(this.weChatId, "snsapi_base");
          if (common.getOpenId(this.weChatId)) return;
        }
      }
    },
    beforeRegisterHandler() {
      registerModel.beforeRegisterHandler(this);
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.getTrackStatus();
      this.initConfig();
      this.loadFormNew();
    },
    skLinkEnd() {
      this.verify = common.getVerify(this.weChatId);
      this.registInit();
    },
    getTrackStatus() {
      if (!common.track_id && !common.tc) {
        return;
      }
      const params = {
        tenantId: common.tenantId,
        track_id: common.track_id,
        tc: common.tc,
        moduleId: 0,
        moduleObjectId: common.webinarId || common.seminarId,
      };
      authService.checkTrackStatus(params).then((data) => {
        if (data.result == 0) {
          if (data.content.status == 0) {
            this.isTrackClosed = true;
          }
        } else {
          console.warn("检查推广链接状态失败:", data.desc);
        }
      });
    },
  },
  created() {
    window.$sk.loading.show();
    if (this.isSetting) {
      this.formInfo = registerData;
      this.formList = this.formInfo.items;
      this.initConfig();
      this.initForm();
      this.isLoad = true;
      window.$sk.loading.hide();
      return;
    }
    this.sk = window.$sk.template.module(this);
  },
  mounted() {
    // this.registInit();
  },
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
